import { Button, ButtonBase, Grid } from "@material-ui/core";
import useStyles from "../../styles"

import { PageHeader } from "../UI/Controls/Controls";
import { TextInput, SelectInput, DateInput, NumberInput } from "../UI/Controls/InputFields";
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { useHistory, useParams } from "react-router";
import { useContext, useEffect, useState } from "react";
import AppIcon from "../UI/Controls/AppIcons";
import AuthContext from "../Auth/AuthContext";
import WebAPI from "../Base/WebAPI";
import useStore from "../Base/Store";
import axios from "axios";
import shallow from 'zustand/shallow';
import { PROJECT_ENTITY } from '../Base/Common';
import { getConfirmOptions, getDatePart, getFinancialEndDate, getFinancialStartDate, isNullOrUndefined, safeBool, safeInt, safeString } from "../Base/Utils";
import { useConfirm } from "material-ui-confirm";
import { tr } from "date-fns/locale";
import { clearCacheByKey } from "../Base/Support";


export default function Project({ isModal = false, prefillName, projectId: projectIdProp = null, onSaved = null, onCloseModal = null, hidePageHeader = false }) {
    const entityName = PROJECT_ENTITY;
    const confirm = useConfirm();
    const [waiting, setWaiting] = useStore(state => [state.waiting, state.setWaiting], shallow);
    const classes = useStyles();
    const history = useHistory();
    const authContext = useContext(AuthContext);
    const [closeDialog, setDialogResponse] = useStore(state => [state.closeDialog, state.setDialogResponse], shallow);
    const invalidateEntityCache = useStore(state => state.invalidateEntityCache);
    const [apiResponseCache, setAPIResponseCache] = useStore(state => [state.apiResponseCache, state.setAPIResponseCache], shallow);

    const { id } = useParams();


    const showAlert = useStore(state => state.showAlert);

    const [fieldValues, setFieldValues] = useState({
        "id": 0,
        "projectName": !isNullOrUndefined(prefillName) ? safeString(prefillName) : "",
        "clientName": "",
        "startDate": getFinancialStartDate(),
        "endDate": getFinancialEndDate(),
        "status": 0,
        "budget": 0,
        "assignedTeam": 0,
        "description": "",
        "notes": "",
        "active": true
    });

    const effectiveProjectId = safeInt(projectIdProp) > 0 ? safeInt(projectIdProp) : safeInt(id);

    useEffect(() => {
        let source = axios.CancelToken.source();
        async function init() {
            if (authContext.token != null) {
                await fetchData(source);
            }
        }
        init();
        return () => {
            source.cancel();
        };
    }, [authContext.token, effectiveProjectId]);

    const fetchData = async (source) => {
        try {
            var projectId = effectiveProjectId;
            if (safeInt(projectId) > 0) {
                setWaiting(true);
                const response = await WebAPI.get('/' + entityName + '/Get' + entityName + 'ById/' + projectId, { headers: { "AccessToken": authContext.token }, cancelToken: source.token });
                if (!!response.data) {
                    if (!!response.data.code && response.data.code > 0) {
                        showAlert(response.data.message, 'error');
                        return;
                    }
                    var projectDetails = { ...fieldValues };

                    projectDetails.id = safeInt(response.data.id);
                    projectDetails.projectName = safeString(response.data.projectName);
                    projectDetails.clientName = safeString(response.data.clientName);
                    projectDetails.startDate = getDatePart(response.data.startDate)
                    projectDetails.endDate = getDatePart(response.data.endDate);
                    projectDetails.status = safeInt(response.data.status);
                    projectDetails.budget = safeInt(response.data.budget);
                    projectDetails.assignedTeam = safeInt(response.data.assignedTeam);
                    projectDetails.description = safeString(response.data.description);
                    projectDetails.notes = safeString(response.data.notes);
                    projectDetails.active = true;

                    setFieldValues(projectDetails);

                }
            }
        } catch (error) {
            if (WebAPI.isCancel(error) === true) {
                console.log('Request cancelled.');
            } else {
                showAlert('Failed to get ' + entityName + '. Internal server error.', 'error');
            }
        } finally {
            setWaiting(false);
        }
    }

    const submitFormData = async (values) => {
        let success = true;
        try {
            var projectId = effectiveProjectId;
            setWaiting(true);
            var apiUrl = '/' + entityName + '/Create' + entityName;
            if (safeInt(projectId) > 0) {
                apiUrl = '/' + entityName + '/Update' + entityName;
            }
            let request = {
                "id": safeInt(projectId),
                "projectName": values.projectName,
                "clientName": values.clientName,
                "startDate": values.startDate,
                "endDate": values.endDate,
                "status": safeInt(values.status),
                "budget": safeInt(values.budget),
                "assignedTeam": safeInt(values.assignedTeam),
                "description": values.description,
                "notes": values.notes,
                "active": true
            };

            const response = await WebAPI.put(apiUrl, request, { headers: { "AccessToken": authContext.token } });

            if (!!response.data.code && response.data.code > 0) {
                success = false;
                showAlert(response.data.message, 'error');
            } else {
                showAlert(entityName + ' saved successfully.', 'success');

                // Invalidate entity summary cache for this project
                if (safeInt(projectId) > 0) {
                    invalidateEntityCache('Project', projectId);
                }

                if (isModal) {
                    if (typeof onSaved === 'function') {
                        onSaved(response.data);
                    } else {
                        setDialogResponse(response.data);
                        closeDialog();
                    }
                } else {
                    history.push("/projectlist");
                }
            }

        } catch (error) {
            success = false;
            showAlert("Failed to save " + entityName + ". Inernal server error occured." + error.response, "error");
        } finally {
            if(success) {
                clearCacheByKey("ProjectList", apiResponseCache, setAPIResponseCache);
            }
            setWaiting(false);
        }
    }

    const deleteProject = async () => {
        confirm(getConfirmOptions('Delete ' + entityName, 'Are you sure, you want to delete ' + entityName + '?'))
            .then(async () => {
                try {
                    setWaiting(true);
                    var response = await WebAPI.put('/' + entityName + '/Delete' + entityName, effectiveProjectId, { headers: { "AccessToken": authContext.token } });
                    if (!!response.data.code && response.data.code > 0) {
                        showAlert(response.data.message, 'error');
                    } else {
                        showAlert(entityName + ' deleted successfully.', 'success');
                        if (isModal) {
                            if (typeof onCloseModal === 'function') {
                                onCloseModal();
                            } else {
                                closeDialog();
                            }
                        } else {
                            history.push('/projectlist');
                        }
                    }
                } catch (error) {
                    showAlert(entityName + ' delete failed. Internal server error.', 'error');
                } finally {
                    setWaiting(false);
                }

            }).catch(() => { });
    }

    return (
        <Formik
            initialValues={fieldValues}
            enableReinitialize={true}
            validationSchema={yup.object({

            })}
            onSubmit={
                async (values) => {
                    await submitFormData(values);
                }
            }
        >
            {({ isSubmitting, values, setFieldValue }) => (
                <Form>
                    <PageHeader heading={safeInt(effectiveProjectId) > 0 ? 'Update Project' : 'Create New Project'}>
                        <AppIcon name="Project" color="primary" />
                    </PageHeader>

                    <div className={classes.page}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <TextInput label="Project Name" name="projectName" placeholder="" required
                                    inputProps={{ autoFocus: true, minLength: 1, maxLength: 100 }} />
                            </Grid>
                            {/* <Grid item xs={12} sm={4}>
                                <TextInput label="Client Name" name="clientName" placeholder="" required
                                    inputProps={{ minLength: 8, maxLength: 16 }} />
                            </Grid> */}
                            <Grid item xs={12} sm={4}>
                                <DateInput label="Start Date" name="startDate" placeholder="" required
                                    inputProps={{}} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <DateInput label="End Date" name="endDate" placeholder="" required
                                    inputProps={{}} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <NumberInput label="Budget" name="budget" placeholder="" required
                                    inputProps={{}} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <SelectInput label="Status" name="status">
                                    <option key="0" value="" />
                                    <option value={1}>{"New"}</option>
                                    <option value={2}>{"In progress"}</option>
                                    <option value={3}>{"Completed"}</option>
                                    <option value={4}>{"Cancelled"}</option>
                                </SelectInput>
                            </Grid>
                            {/* <Grid item xs={12} sm={4}> */}

                            {/* <SelectInput label="Assigned Team" name="assignedTeam">
                                    <option key="0" value="" />
                                    <option value={1}>{"Bishal Singh"}</option>
                                    <option value={2}>{"Arvind Sir"}</option>
                                    <option value={3}>{"Manoj Sir"}</option>
                                </SelectInput> */}
                            {/* </Grid> */}
                            <Grid item xs={12} sm={4}>
                                <TextInput label="Description" name="description" placeholder="" inputProps={{ className: classes.textarea, maxLength: 200 }} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput label="Notes" name="notes" placeholder="" inputProps={{ className: classes.textarea, maxLength: 200 }} />
                            </Grid>

                            <Grid item xs={8}></Grid>
                            <Grid item container xs={10} sm={8} className={classes.mt1}>
                                <Button type="submit"
                                    variant="contained"
                                    color="primary"
                                >
                                    Save
                                </Button>
                                <Button variant="outlined" color="primary" className={classes.ml1} onClick={() => isModal ? (typeof onCloseModal === 'function' ? onCloseModal() : closeDialog()) : history.go(-1)}>{isModal ? "Close" : "Back"}</Button>
                            </Grid>

                            {(safeInt(effectiveProjectId) > 0 && !safeBool(isModal)) &&
                                <Grid item container xs={2} sm={4} className={classes.pullRight} alignItems="center">
                                    <ButtonBase title="Delete Project" onClick={() => deleteProject()}>
                                        <AppIcon color="error" name="Delete" size="large" />
                                    </ButtonBase>
                                </Grid>
                            }
                        </Grid>

                    </div>
                </Form>
            )
            }

        </Formik >
    );
};